const defaultEventsList = ["rent_now_click", "buy_now_click", "rent_now_cta", "buy_now_cta", "rent_now_again"];
const TVODCommonParams = data => {
  return {
    page_type: data.pageType,
    lp_name: data.pathname,
    title_id: data.titleId,
    title_name: data.title,
    channels_type: data.addonContent,
    content_type: data.tagList,
    subscription_value: data.price || "",
    subscription_modal: data.modalType || "",
    currency: data.currency || "",
    a_profile_id: data.profileId
  };
};
export function TVODParams(action, data) {
  let params = null;
  if (defaultEventsList.includes(action)) {
    params = TVODCommonParams(data);
  }
  return params;
}
